import { render } from "./back.vue?vue&type=template&id=e6c460e6&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import "./back.vue?vue&type=style&index=0&id=e6c460e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c460e6"]])

export default __exports__